import { NgModule } from "@angular/core"
import { CommonModule } from "@angular/common"
import { PagesRoutingModule } from "./pages-routing.module"
import { PagesComponent } from "./pages.component"
import { PartialsModule } from "../shared/partials.module"
import {
	MatInputModule,
	MatCardModule,
	MatTableModule,
	MatButtonModule,
	MatPaginatorModule,
	MatSortModule,
	MatTooltipModule,
	MatProgressSpinnerModule,
	MatAutocompleteModule,
	MatSelectModule
} from "@angular/material"
import { ServicesMenuComponent } from "./services-menu/services-menu.component"
import { TranslateModule } from "@ngx-translate/core"
import { CatalogTransportComponent } from "./catalog/catalog-transport/catalog-transport.component"
import { SignupMainComponent } from "./signup-main/signup-main.component"
import { ReactiveFormsModule } from "@angular/forms"
import { ContactComponent } from "./contact/contact.component"
import { MaintenanceComponent } from "./maintenance/maintenance.component"
import { DownloadAreaComponent } from "./download-area/download-area.component"
import { NotificationAreaComponent } from "./notification-area/notification-area.component"
import { ErrorReportComponent } from "./error-report/error-report.component"
import { NetworkCoverageComponent } from "./network-coverage/network-coverage.component"
import { PointToPointComponent } from "./point-to-point/point-to-point.component"
import { AuthModule } from "src/app/auth/auth.module"

@NgModule({
	declarations: [
		CatalogTransportComponent,
		ErrorReportComponent,
		PagesComponent,
		ServicesMenuComponent,
		SignupMainComponent,
		ContactComponent,
		MaintenanceComponent,
		DownloadAreaComponent,
		NotificationAreaComponent,
		ContactComponent,
		NetworkCoverageComponent,
		PointToPointComponent
	],
	imports: [
		CommonModule,
		PagesRoutingModule,
		PartialsModule,
		MatCardModule,
		MatInputModule,
		MatTableModule,
		MatButtonModule,
		MatPaginatorModule,
		MatSortModule,
		MatTooltipModule,
		MatProgressSpinnerModule,
		TranslateModule,
		ReactiveFormsModule,
		MatAutocompleteModule,
		MatSelectModule,
		AuthModule
	],
	exports: [PagesComponent, PartialsModule]
})
export class PagesModule {}
